import { render } from "./BillingDetailWithDeliveryPDF.vue?vue&type=template&id=e8bc4cc4&scoped=true"
import script from "./BillingDetailWithDeliveryPDF.vue?vue&type=script&lang=js"
export * from "./BillingDetailWithDeliveryPDF.vue?vue&type=script&lang=js"

import "./BillingDetailWithDeliveryPDF.vue?vue&type=style&index=0&id=e8bc4cc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8bc4cc4"]])

export default __exports__